window.initHubArticle ?? (() => {
    window.initHubArticle = (section_id) => {

        const hubArticle = {};

        hubArticle.article = document.querySelector('.hub-article-content-inner');
        hubArticle.progress = document.querySelector('.toc-progress');
        hubArticle.tocList = document.querySelector('.toc-list');

        function updateProgress() {

            const articleTop =
                hubArticle.article.getBoundingClientRect().top + window.scrollY;

            const articleHeight = hubArticle.article.offsetHeight;

            const viewportMiddle =
                window.scrollY + window.innerHeight / 2;

            let percentage =
                ((viewportMiddle - articleTop) / articleHeight) * 100;

            percentage = Math.max(0, Math.min(100, percentage));

            hubArticle.progress.style.height = `${percentage}%`;

            let currentIndex = -1;

            hubArticle.headings.forEach((heading, index) => {
                const headingTop =
                    heading.getBoundingClientRect().top + window.scrollY;

                if (viewportMiddle >= headingTop) {
                    currentIndex = index;
                }
            });

            hubArticle.links.forEach((link, index) => {
                link.classList.toggle('active', index <= currentIndex);
            });
        }

        function buildToc() {

            if (!hubArticle.article || !hubArticle.tocList) return;

            hubArticle.tocList.innerHTML = '';

            hubArticle.article.querySelectorAll('h2').forEach((heading, index) => {
                const id = heading.textContent
                .trim()
                .toLowerCase()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-')
                || `section-${index + 1}`;

                heading.id = id;

                hubArticle.tocList.insertAdjacentHTML(
                    'beforeend',
                    `
                        <li>
                        <a href="#${id}">
                            ${heading.textContent}
                        </a>
                        </li>
                    `
                );
            });

            hubArticle.links = document.querySelectorAll('.toc-list a');
            hubArticle.headings = document.querySelectorAll('.hub-article-content-inner h2');

            updateProgress();
            window.addEventListener('scroll', updateProgress);
            window.addEventListener('resize', updateProgress);
        }

        buildToc();       
        
    }
          
})();